import { Navigate } from "react-router-dom";
import { useHasPublishedNews } from "../../hooks/useHasPublishedNews";

export type Props = {
  /**
   * Where to send a reader when nothing is published. `/news` answers as any
   * other missing page does, since that address promises the section itself.
   * `/blog` is an old address people may still hold, so it goes to the
   * homepage rather than telling them their link is dead.
   */
  whenNone?: string;
};

/**
 * What the addresses naming the news section answer.
 *
 * The section they name exists only once something is published, so until then
 * neither may send a reader to an anchor that is not on the homepage: they
 * would land silently at the top with no sign anything had gone wrong.
 */
export function NewsAddressGuardContainer({ whenNone = "/not-found" }: Props) {
  const { hasPublishedNews, isLoading } = useHasPublishedNews();

  // Nothing is drawn while the answer is on its way: this address only ever
  // redirects, and guessing which way would send some readers to the wrong
  // place and then move them.
  if (isLoading) return null;

  return <Navigate to={hasPublishedNews ? "/#news" : whenNone} replace />;
}

export default NewsAddressGuardContainer;
